/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { CELL_TEXT_CENTER_CLASS } from '@gh/common-internal-shared';
import { NumberTypes } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { buildNumberColumn, ManualGridDefinition } from '@gh/core-ui-grid';
import { ColDef, GridOptions } from 'ag-grid-community';

@Injectable()
export class ItemGridDefinition extends ManualGridDefinition {

  constructor(private translationService: TranslationService) {
    super();
  }

  buildGridOptions(): GridOptions {
    return { getRowId: (params) => String(params.data.id)};
  }

  buildColumnDefs(): ColDef[] {
    return [{
      field: 'code',
      headerName: this.translationService.get('lbl_code'),
      width: 120,
    },
      {
        field: 'description',
        headerName: this.translationService.get('lbl_description'),
        width: 250,
      },
      {
        field: 'costCenterCode',
        headerName: this.translationService.get('lbl_cost_center'),
        width: 120,
        cellClass: CELL_TEXT_CENTER_CLASS,
      },
      {
        field: 'cost',
        headerName: this.translationService.get('lbl_cost_dollar'),
        width: 120,
        ...buildNumberColumn(NumberTypes.Price),
      },
      {
        field: 'uomCode',
        headerName: this.translationService.get('lbl_uom_abbreviation'),
        width: 100,
      },
      {
        field: 'quantity',
        headerName: this.translationService.get('lbl_qty'),
        width: 120,
        ...buildNumberColumn(NumberTypes.Quantity),
      },
      {
        field: 'extension',
        headerName: this.translationService.get('lbl_extension_dollar'),
        width: 120,
        ...buildNumberColumn(NumberTypes.Price),
      }];
  }

}
